import { useState } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { updateServiceStatus } from "API/index";

const ServiceStatusSwitch = ({ serviceId, status, onStatusChange }) => {
  const [loading, setLoading] = useState(false);

  const isActive = status === "active";

  const handleChange = async (e) => {
    const newStatus = e.target.checked ? "active" : "inactive";

    // 🔥 Optimistic UI update (parent state)
    onStatusChange(serviceId, newStatus);

    setLoading(true);
    try {
      await updateServiceStatus(serviceId, newStatus);
    } catch (error) {
      console.error("Failed to update service status", error);

      // ❌ Rollback on failure
      onStatusChange(
        serviceId,
        newStatus === "active" ? "inactive" : "active"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={isActive}
          onChange={handleChange}
          disabled={loading}
        />
      }
      label={isActive ? "Active" : "Inactive"}
    />
  );
};

export default ServiceStatusSwitch;
